import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import serviceWorkerManager from './utils/serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for caching and offline support
if (process.env.NODE_ENV === 'production') {
  serviceWorkerManager.register().then((registered) => {
    if (registered) {
      console.log('Service Worker registered for blog caching');
      // Request notification permission for update notifications
      serviceWorkerManager.requestNotificationPermission();
    }
  });
}
